import { render, staticRenderFns } from "./new.vue?vue&type=template&id=8e597b94&"
import script from "./new.vue?vue&type=script&lang=js&"
export * from "./new.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/easy_dev/extranet/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8e597b94')) {
      api.createRecord('8e597b94', component.options)
    } else {
      api.reload('8e597b94', component.options)
    }
    module.hot.accept("./new.vue?vue&type=template&id=8e597b94&", function () {
      api.rerender('8e597b94', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/client/new.vue"
export default component.exports